import React from 'react';
import {
  Container,
  CssBaseline,
  TextField,
  Button,
  Typography,
  makeStyles,
  Snackbar,
} from '@material-ui/core';
import BaliardaLogo from '../../content/images/logos baliarda/logo-color.png';
import {i18n2} from 'features/i18n/i18n';
import {Trans} from '@lingui/macro';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logo: {
    height: 'auto',
    width: 'auto',
    maxHeight: '200px',
    verticalAlign: 'middle',
  },
  form: {width: '100%', marginTop: theme.spacing(1)},
  submit: {margin: theme.spacing(3, 0, 2)},
}));

export default function RecoverPassword() {
  const classes = useStyles();
  const [value, setValue] = React.useState('');
  const [message, setMessage] = React.useState({open: false, text: ''});
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch('/api/Auth/recover-password', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({CwidOrEmail: value}),
      });
      if (res.ok) {
        setMessage({
          open: true,
          text: 'Si existe una cuenta asociada, recibirá un correo con instrucciones.',
        });
      } else {
        setMessage({
          open: true,
          text: 'Si existe una cuenta asociada, recibirá un correo con instrucciones.',
        });
      }
    } catch (err) {
      setMessage({open: true, text: 'Error de conexión'});
    }
    setLoading(false);
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <img src={BaliardaLogo} className={classes.logo} alt="Mox It Logo" />
        <Typography component="h1" variant="h5">
          <Trans>Recuperar contraseña</Trans>
        </Typography>
        <form className={classes.form} onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label={i18n2._('CWID o Email')}
            name="cwidOrEmail"
            autoFocus
            onChange={(e) => setValue(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={loading}>
            <Trans>Enviar</Trans>
          </Button>
        </form>
      </div>
      <Snackbar
        open={message.open}
        autoHideDuration={4000}
        onClose={() => setMessage({...message, open: false})}
        message={i18n2._(message.text)}
      />
    </Container>
  );
}
